export default __webpack_public_path__ + "static/media/3.fb4e3575.png";